import setState from '../utils/storeUtils';

/**
 * @typedef menuState
 * @type {object}
 * @property {string} groupRenderType indicates the value to avoid View all in a category
 * @property {string} blockRenderType indicates the value to avoid View all in a category and set the special category styles
 * @property {Boolean} isClosedMenu menu closed state
 * @property {integer} menuCategoriesHeight categories layer height
 * @property {string} activeSubmenuBgColor background color of the currently visible submenu panel
 * @property {{dark: string, light: string}} backButtonColors fixed color variants for the submenu back button
 */
const initialState = {
  groupRenderType: '',
  blockRenderType: '',
  isClosedMenu: true,
  menuCategoriesHeight: 0,
  activeSubmenuBgColor: null,
  backButtonColors: { dark: null, light: null },
};

export const types = {
  setGroupRenderType: 'menu/setGroupRenderType',
  setBlockRenderType: 'menu/setBlockRenderType',
  setIsClosedMenu: 'menu/setIsClosedMenu',
  setMenuCategoriesHeight: 'menu/setMenuCategoriesHeight',
  setMenuState: 'menu/setMenuState',
  setActiveSubmenuBgColor: 'menu/setActiveSubmenuBgColor',
  setBackButtonColors: 'menu/setBackButtonColors',
};

// getters
const getters = {};

// actions
const actions = {
  setMenuState({ commit }, { isClosed = true, categoriesHeight = 0 }) {
    commit('setIsClosedMenu', isClosed);
    commit('setMenuCategoriesHeight', categoriesHeight);
  },
};

// mutations
const mutations = {
  setGroupRenderType: setState('groupRenderType'),
  setBlockRenderType: setState('blockRenderType'),
  setIsClosedMenu: setState('isClosedMenu'),
  setMenuCategoriesHeight: setState('menuCategoriesHeight'),
  setActiveSubmenuBgColor: setState('activeSubmenuBgColor'),
  setBackButtonColors: setState('backButtonColors'),
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
